<template>
  <teleport to="body">
    <div class="am-overlay" @mousedown.self="$emit('close')" @keydown.esc="$emit('close')">
      <div class="am-card" :class="{ 'am-card--wide': wide }" role="dialog" aria-modal="true" :aria-label="title">
        <header class="am-head">
          <h2 class="am-title">{{ title }}</h2>
          <button class="am-x" type="button" aria-label="Cerrar" @click="$emit('close')"><span class="mdi mdi-close"></span></button>
        </header>
        <div class="am-body"><slot /></div>
        <footer v-if="$slots.footer" class="am-foot"><slot name="footer" /></footer>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'

const emit = defineEmits(['close'])
defineProps({ title: { type: String, required: true }, wide: { type: Boolean, default: false } })

function onKey(e) { if (e.key === 'Escape') emit('close') }
onMounted(() => window.addEventListener('keydown', onKey))
onBeforeUnmount(() => window.removeEventListener('keydown', onKey))
</script>

<style scoped>
.am-overlay {
  position: fixed; inset: 0; z-index: 10000; background: rgba(15, 23, 42, 0.55);
  display: flex; align-items: center; justify-content: center; padding: 16px;
}
.am-card {
  width: 100%; max-width: 440px; max-height: calc(100vh - 32px); display: flex; flex-direction: column;
  background: #fff; border-radius: 12px; box-shadow: 0 20px 50px rgba(15, 23, 42, 0.3); overflow: hidden;
}
.am-card--wide { max-width: 600px; }
.am-head { display: flex; align-items: center; gap: 8px; padding: 16px 20px 8px; }
.am-title { flex: 1; margin: 0; font: 700 16px var(--font-display); color: #1e3a5f; }
.am-x { border: none; background: none; cursor: pointer; font-size: 20px; color: #64748b; display: flex; padding: 4px; border-radius: 6px; }
.am-x:hover { background: #f1f5f9; }
.am-body { padding: 8px 20px 16px; overflow: auto; font: 400 13px Inter, sans-serif; color: #334155; }
.am-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 20px 16px; border-top: 1px solid #eef1f6; }
</style>